import React, { useState, useEffect, useCallback } from 'react';
import Navigation from './Navigation';
import { useI18n } from '../i18n';
import LanguageSelector from './LanguageSelector';

const Header = ({ activeTab, onTabChange, lang, onToggleLang, role, onLogout }) => {
  const { t } = useI18n();
  const [menuOpen, setMenuOpen] = useState(false);

  // Close menu on resize to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Close menu when a tab is selected
  const handleTabChange = useCallback((tab) => {
    setMenuOpen(false);
    onTabChange(tab);
  }, [onTabChange]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <header className="header">
      <div className="header-logo">
        <img src="/LOGO.png" alt="Hacienda de Aldama Logo" />
      </div>
      <div className="header-center">
        <div className="header-title" style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>{t('brand')}</div>
        <div className="header-nav desktop-nav">
          <Navigation activeTab={activeTab} onTabChange={onTabChange} role={role} />
        </div>
      </div>
      <div className="header-right">
        <LanguageSelector lang={lang} onChange={(v) => onToggleLang ? onToggleLang(v) : null} />
        <button className="logout-btn" onClick={onLogout}>Log out</button>
        <button
          className={`hamburger-btn ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span className="hamburger-line" />
          <span className="hamburger-line" />
          <span className="hamburger-line" />
        </button>
      </div>

      {/* Mobile slide-out menu */}
      <div className={`mobile-menu-overlay ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(false)} />
      <nav className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <span className="mobile-menu-brand">{t('brand')}</span>
          <button className="mobile-menu-close" onClick={() => setMenuOpen(false)} aria-label="Close menu">✕</button>
        </div>
        <div className="mobile-menu-nav">
          <Navigation activeTab={activeTab} onTabChange={handleTabChange} role={role} />
        </div>
      </nav>
    </header>
  );
};

export default Header;
